var svRegional = require('./datepicker-regional-sv');
var engbRegional = require('./datepicker-regional-engb');

global.SweaDatepickers = (function ($) {
	var _nonBankingDays = [];
	var _isSwedishPage = $('html').is(':lang(sv)');

    function init(nonBankingDays, startDay) {
		_nonBankingDays = nonBankingDays;

		var startBaseConfig = {
			beforeShowDay: function (date) {
				// Wants an array
				return [isDateSelectableAsStart(date, startDay)];
			},
			changeMonth: true,
			changeYear: true,
			selectOtherMonths: true,
			showOtherMonths: true,
			maxDate: new Date()
		};

		var endBaseConfig = {
			beforeShowDay: function (date) {
				// Wants an array
				return [isDateSelectableAsEnd(date, startDay)];
			},
			changeMonth: true,
			changeYear: true,
			selectOtherMonths: true,
			showOtherMonths: true,
			maxDate: new Date()
		};

        var regional = _isSwedishPage ? svRegional : engbRegional;

		var startConfig = $.extend({}, startBaseConfig, regional);
		var endConfig = $.extend({}, endBaseConfig, regional);

		$('#datetime-from').datepicker(startConfig);
		$('#datetime-to').datepicker(endConfig);

		$('#datetime-from, #datetime-to').change(function() {
			handleDateChange($(this));
		});
    }

    function parseUkDateString(dateString) {
    	return dateString.split('/').reverse().join();
	}

	function handleDateChange($input) {
		var date = parseDate($input.val());
		var $validationMessage = $input.siblings('.js-validation-date');

		if (isDateSelectable(date)) {
			$input.toggleClass('state--error', false);
			$validationMessage.toggleClass('error-text--visible', false);
			$('.js-submit-form').prop('disabled', false);
		}
		else {
			$input.toggleClass('state--error', true);
			$validationMessage.toggleClass('error-text--visible', true);
			$('.js-submit-form').prop('disabled', true);
		}
	}

	function parseDate(input) {
		var value = _isSwedishPage ? input : parseUkDateString(input);
		return new Date(value);
	}

	function isDateSelectable(date, startDate) {
		var SUNDAY = 0;
		var SATURDAY = 6;
		var closedDays = [SATURDAY, SUNDAY];

		if (date > new Date()) {
			return false;
		}

		if (startDate && date < startDate) {
			return false;
		}

		if (closedDays.indexOf(date.getDay()) > -1) {
			return false;
		}

		var formattedDate = jQuery.datepicker.formatDate('yy-mm-dd', date);
		return _nonBankingDays.indexOf(formattedDate) === -1;
	}

	function isDateSelectableAsStart(date, startDate) {
		if (date > parseDate($('#datetime-to').val())) {
			return false;
		}
		return isDateSelectable(date, startDate);
	}

	function isDateSelectableAsEnd(date, startDate) {
		if (date < parseDate($('#datetime-from').val())) {
			return false;
		}
		return isDateSelectable(date, startDate);
	}

	return {
		init: init
	};
})(jQuery);
